import {Component} from 'vue-property-decorator';
import Vue from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    wx: any;
  }
}

@Component
export default class wxMixin extends Vue {

}
